import React from 'react'
import styled from 'styled-components'
import Spinner from 'react-loader-spinner'
import { Link } from 'react-router-dom'
import { IconArrowLeft } from '@loadsmart/icons'
import { formatDate } from 'utils/dateUtils'

const Return = styled(Link)`
  display: flex;
  background: ${({ theme }) => theme.colors.backgroundReturnLink};
  padding: 5px;
  border-radius: 20px;
`
const Title = styled.span`
  font-weight: 500;
  font-size: 20px;
  line-height: 26px;
`
const Label = styled.span`
  font-weight: bold;
  font-size: 20px;
  line-height: 26px;
`
const ContractDates = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
`
const Column = styled.div<{ grow?: number; align?: string }>`
  padding: 0 10px;
  ${({ grow }) => grow && `flex-grow: ${grow}`}
  ${({ align }) => align && `align-self: ${align}`}
`
const Container = styled.div`
  display: flex;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderLight};
`
export default function Header({
  rfp,
  isLoading,
}: {
  rfp: RequestForProposalDetail | undefined
  isLoading: boolean
}) {
  return (
    <Container>
      <Column>
        <Return to={`/shipper/rfp/${rfp?.id}`} data-testid="return-link">
          <IconArrowLeft width={24} height={24} />
        </Return>
      </Column>

      {isLoading && (
        <Column grow={4} data-testid="loading-spinner">
          <Spinner type="TailSpin" width={35} height={35} />
        </Column>
      )}
      {!isLoading && rfp && (
        <Column grow={4}>
          <div>
            <Title>{rfp?.name}</Title> / <Label>Carriers</Label>
          </div>
          <ContractDates>
            Start: {rfp && formatDate(rfp.contract_start)} - End:{' '}
            {rfp && formatDate(rfp.contract_end)}
          </ContractDates>
        </Column>
      )}
    </Container>
  )
}
